module.exports = __webpack_public_path__ + "img/back.815ccd02.png";